module.exports = __webpack_public_path__ + "static/media/RVTN03.3d008d88.jpg";